module.exports = {"360802001":"古南街道","360802002":"永叔街道","360802003":"文山街道","360802004":"习溪桥街道","360802005":"北门街道","360802006":"白塘街道","360802007":"禾埠街道","360802100":"兴桥镇","360802101":"樟山镇","360802102":"长塘镇","360802103":"曲濑镇","360802400":"吉州区工业园小区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/360802.json
// module id = 1304
// module chunks = 0